import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closePostCredentialModal } from 'app/dispatcher/modalDispatcher';
import { Modal } from 'app/seedly-component-library';
import { RootState } from 'app/reducer';

function withModal(WrappedComponent) {
  const ModalHoc = props => {
    const isPostCredentialModalOpen = useSelector(
      (state: RootState) => state.modal.isPostCredentialModalOpen,
    );
    const dispatch = useDispatch();

    const { isEdit, resetForm } = props;

    const closeForm = () => {
      dispatch(closePostCredentialModal());
      resetForm();
    };

    return (
      <Modal
        ariaHideApp={false}
        isOpen={isPostCredentialModalOpen}
        onRequestClose={closeForm}
        headerTitle={isEdit ? 'Edit Credential' : 'Add Credential'}
        withCloseButton
        label="post-credential"
      >
        <WrappedComponent {...props} />
      </Modal>
    );
  };

  return ModalHoc;
}

export default withModal;
